import Bluebird from 'bluebird'
import { isArray } from 'lodash'
import store from '../../store' // TODO: stop including this directly
import { percentOfParent } from './helpers'

// Keep renderers in their own files
import shape from './shape_renderer'
import text from './text_renderer'
import image from './image_renderer'
import { projectItem } from './item_projector'

const RENDERERS = { shape, text, image }

export function renderItem(doc, game, component, item, parentDimensions, index, total) {
  // get layers for this component
  const
    template = store.getters.findTemplate(component.templateId),
    layers = store.getters.findAllTemplateLayers(template),
    selectedLayer = store.getters.activeLayer,
    results = { operations: [], issues: [] }

  if(!isArray(parentDimensions)) {
    parentDimensions = [ parentDimensions ]
  }

  // render each layer
  return Bluebird.each(layers, layer => {
    // Always revert to defaults (so layer styles don't bleed into each other)
    layerDefaults(doc)

    return Bluebird.each(parentDimensions, (dimensions) => {
      // TODO: modify with layout dimensions
      // Magic properties from the source affect layer defaults
      const projectedLayer = projectItem(layer, item)

      // early out for hidden layers
      if(!projectedLayer.visible) { return Promise.resolve() }

      const
        layerDimensions = percentOfParent(store.getters.getLayerDimensions(layer), dimensions),
        layerRenderer = RENDERERS[projectedLayer.type]

      if(!layerRenderer) {
        results.issues.push(`Unknown layer type: "${projectedLayer.type}"`)
        return Promise.resolve()
      }

      // what page is this item's location on?
      doc.setPage(dimensions.page)

      // Type-specific layer renderers
      const opacity = projectedLayer.opacity !== undefined ? projectedLayer.opacity : 1
      const hasOpacity = opacity < 1
      if (hasOpacity) {
        doc.saveGraphicsState()
        doc.setOpacity(opacity)
      }
      return Bluebird.try(() => layerRenderer.render(doc, projectedLayer, layerDimensions, item, index, total))
        .catch(error => {
          results.issues.push(error.message || error)
        })
        .finally(() => {
          if (hasOpacity) doc.restoreGraphicsState()
        })
    })
  }).then(() => {
    if(selectedLayer && store.getters.layerHighlighting) {
      renderHighlightLayer(doc, selectedLayer, parentDimensions[0])
    }
  }).then(() => results)
}

export function layerDefaults(doc) {
  doc.setFontSize(16)
  doc.setLineWidth(.02)
  doc.setDrawColor(0)
  doc.setFillColor(0)
}

export function renderHighlightLayer(doc, selectedLayer, parentDimensions) {
  const layerDimensions = percentOfParent(store.getters.getLayerDimensions(selectedLayer), parentDimensions)

  const cornerTopLeft = selectedLayer.cornerTopLeft || 0
  const cornerTopRight = selectedLayer.cornerTopRight || 0
  const cornerBottomLeft = selectedLayer.cornerBottomLeft || 0
  const cornerBottomRight = selectedLayer.cornerBottomRight || 0
  const textRotation = selectedLayer.textRotation || 0

  const x = layerDimensions.x
  const y = layerDimensions.y
  const w = layerDimensions.w
  const h = layerDimensions.h

  const tlInset = cornerTopLeft * w
  const trInset = cornerTopRight * w
  const blInset = cornerBottomLeft * w
  const brInset = cornerBottomRight * w

  doc.setDrawColor(255, 0, 0)
  doc.setLineWidth(0.02)

  if (textRotation !== 0) {
    const PTS_PER_INCH = 72
    const pageHeight = doc.internal.pageSize.height
    const cx = (x + w / 2) * PTS_PER_INCH
    const cy = (pageHeight - (y + h / 2)) * PTS_PER_INCH
    const angleRad = (textRotation * Math.PI) / 180
    const cos = Math.cos(angleRad)
    const sin = Math.sin(angleRad)
    const fmt = n => Math.abs(n) < 1e-10 ? 0 : Math.round(n * 10000) / 10000
    doc.saveGraphicsState()
    doc.setCurrentTransformationMatrix(
      fmt(cos), fmt(sin), fmt(-sin), fmt(cos),
      fmt(cx - cx * cos + cy * sin),
      fmt(cy - cx * sin - cy * cos)
    )
  }

  doc.line(x + tlInset, y, x + w - trInset, y)
  doc.line(x + w - trInset, y, x + w - brInset, y + h)
  doc.line(x + w - brInset, y + h, x + blInset, y + h)
  doc.line(x + blInset, y + h, x + tlInset, y)

  if (textRotation !== 0) {
    doc.restoreGraphicsState()
  }
}
